// extracted by mini-css-extract-plugin
export default {"examContainer":"Exam_examContainer__HC5yu"};